import { createAction, props } from '@ngrx/store';
import { ContactResponse } from '../../../admin/interfaces/find-email.interface';
import { AssignUserRoleRequest } from '../../../admin/interfaces/user-accout.interface';

export enum CustomerActionTypes {
    LoadCustomerContacts = '[Customer] Load Contacts',
    LoadCustomerContactsFinished = '[Customer] Load Contacts Finished',
    CleanCustomerContacts = '[Customer] Clean Customer Contacts',
    AssignOrRevokePermission = '[Customer] assign or revoke permissison',
    AssignOrRevokePermissionFinished = '[Customer] assign or revoke permissison finished',
    LoadLiveLink = '[Customer] Load LiveLink',
    LoadLiveLinkFinished = '[Customer] Load LiveLink Finished'
}

export const loadCustomerContacts = createAction(CustomerActionTypes.LoadCustomerContacts, props<{ customerId: string }>());

export const loadCustomerContactsFinished = createAction(CustomerActionTypes.LoadCustomerContactsFinished, props<{ contacts: ContactResponse[] }>());

export const cleanAccountContact = createAction(CustomerActionTypes.CleanCustomerContacts);

export const assignOrRevokePermission = createAction(CustomerActionTypes.AssignOrRevokePermission, props<{ data: AssignUserRoleRequest }>());

export const loadLiveLink = createAction(CustomerActionTypes.LoadLiveLink, props<{ customerId: string }>());

export const loadLiveLinkFinished = createAction(CustomerActionTypes.LoadLiveLinkFinished, props<{ livelinkUrl: string | undefined; livelinkExpiry: string | undefined }>());
